import React from 'react'

interface Props {
  size: number
  fillColor: string
}
const Stake: React.FC<Props> = props => {
  const { size, fillColor } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20.995 21">
      <g id="Stake_and_Earn" data-name="Stake and Earn" transform="translate(66 24)">
        <path
          id="Path_2496"
          data-name="Path 2496"
          d="M-468.808-266.785c-.052.363-.092.729-.157,1.09a9.452,9.452,0,0,1-3.446,5.8,9.259,9.259,0,0,1-5.04,2.068c-.552.054-1.114.008-1.653.008-.052-.42-.078-.844-.162-1.256s-.225-.811-.347-1.238c.169.016.346.034.524.05a7.169,7.169,0,0,0,7.705-5.882,7.177,7.177,0,0,0-5.653-8.3,7.177,7.177,0,0,0-8.3,5.073.286.286,0,0,1-.289.243,4,4,0,0,0-2.258,1.065c-.048.045-.1.088-.147.132l-.058-.017c.077-.508.113-1.026.239-1.522a9.372,9.372,0,0,1,7.545-7.374,9.59,9.59,0,0,1,11.316,7.591c.078.407.119.821.177,1.232Z"
          transform="translate(423.804 253.045)"
          fill={fillColor}
        />
        <path
          id="Path_2497"
          data-name="Path 2497"
          d="M-518.993,6.861a.771.771,0,0,1-.456-.825,10.415,10.415,0,0,1,.126-2.079,4.73,4.73,0,0,1,1.892-2.8.214.214,0,0,1,.3,0,4.057,4.057,0,0,0,4.782.012.238.238,0,0,1,.335-.006,4.686,4.686,0,0,1,1.992,3.725c.017.382-.012.766.009,1.147a.764.764,0,0,1-.456.826Z"
          transform="translate(453.45 -9.861)"
          fill={fillColor}
        />
        <path
          id="Path_2498"
          data-name="Path 2498"
          d="M-413.629-199.158a4.122,4.122,0,0,0-2.477-6.281,5.505,5.505,0,0,1,1.221-2.222,5.706,5.706,0,0,1,6.068-1.816,5.665,5.665,0,0,1,4.256,4.666,5.926,5.926,0,0,1-5.262,6.958,5.892,5.892,0,0,1-2.712-.367.514.514,0,0,1-.159-.086C-413-198.583-413.309-198.865-413.629-199.158Zm5.475-6.433a2.18,2.18,0,0,0-1.374-1.881.357.357,0,0,1-.269-.39.6.6,0,0,0-.915-.531.627.627,0,0,0-.307.625c.007.113,0,.192-.142.245a2.239,2.239,0,0,0-1.457,2.542,2.264,2.264,0,0,0,2.192,1.83,1.026,1.026,0,0,1,1.045,1.033,1.029,1.029,0,0,1-1,1.016,1.026,1.026,0,0,1-1.048-1.01.619.619,0,0,0-.641-.628.612.612,0,0,0-.585.679,2.183,2.183,0,0,0,1.384,2c.194.085.274.164.258.377a.56.56,0,0,0,.3.542.6.6,0,0,0,.912-.514.387.387,0,0,1,.291-.419,2.146,2.146,0,0,0,1.351-1.962,2.243,2.243,0,0,0-2.237-2.348,1.026,1.026,0,0,1-1.035-1.024,1.027,1.027,0,0,1,.991-1.025,1.025,1.025,0,0,1,1.058,1,.621.621,0,0,0,.631.639C-408.391-204.8-408.143-205.088-408.154-205.591Z"
          transform="translate(355.766 189.41)"
          fill={fillColor}
        />
        <path
          id="Path_2499"
          data-name="Path 2499"
          d="M-479.911-107.793a2.875,2.875,0,0,1-2.871,2.863,2.876,2.876,0,0,1-2.868-2.887,2.875,2.875,0,0,1,2.881-2.852A2.874,2.874,0,0,1-479.911-107.793Z"
          transform="translate(421.5 95.781)"
          fill={fillColor}
        />
      </g>
    </svg>
  )
}

export default Stake
